import {AbstractValidatable, DateCustom, ValidationErrorsObject} from "frontend-core";

export class SegmentCommission extends AbstractValidatable {
    public commission: number;
    public futureCommission: Array<IFutureCommissionInnerDto>;

    public errors: ValidationErrorsObject<{
        commission: string[],
        futureCommission: string[],
    }> = {
        commission: [],
        futureCommission: [],
    };

    constructor(commission: number, futureCommission: IFutureCommissionDto) {
        super();

        this.commission = commission;

        if (futureCommission.length > 0) {
            this.futureCommission = futureCommission.map((item) => {
                return {
                    commission: item.commission,
                    dateStart: new DateCustom(item.dateStartCommission),
                }
            });
        } else {
            this.futureCommission = [];
        }
    }
}

export type ISegmentCommissionDto = Readonly<{
    commission: number;
    futureCommission: IFutureCommissionDto;
}>

export type IFutureCommissionInnerDto = {
    commission: number;
    dateStart: DateCustom;
}

export type IFutureCommissionDto = Array<{
    commission: number;
    dateStartCommission: string;
}>;
